module.exports = __webpack_public_path__ + "static/img/funny_15.9b8de141.jpg";